export default "__VITE_ASSET__2gFIMKzW__"